function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSearchIcon = function SvgSearchIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27,
    height: 27
  }, props), /*#__PURE__*/React.createElement("circle", {
    cx: 9.899,
    cy: 9.899,
    r: 6,
    fill: "none",
    strokeWidth: 2,
    style: {
      stroke: "currentcolor"
    },
    transform: "rotate(-45 9.9 9.9)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 9,
    x: 14.441,
    y: 15.153,
    rx: 0.5,
    style: {
      fill: "currentcolor",
      stroke: "currentcolor"
    },
    transform: "rotate(-45 14.441 15.153)"
  }));
};
export { SvgSearchIcon as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNyIgaGVpZ2h0PSIyNyIgdmlld0JveD0iMCAwIDI3IDI3Ij4KICAgIDxzdHlsZT4KICAgICAgICAuY2lyY2xlIHsKICAgICAgICAgICAgc3Ryb2tlOiBjdXJyZW50Y29sb3I7CiAgICAgICAgfQogICAgICAgIC5yZWN0IHsKICAgICAgICAgICAgZmlsbDogY3VycmVudGNvbG9yOwogICAgICAgICAgICBzdHJva2U6IGN1cnJlbnRjb2xvcjsKICAgICAgICB9CiAgICA8L3N0eWxlPgogICAgPGNpcmNsZSBjbGFzcz0iY2lyY2xlIiBjeD0iOS44OTk1IiBjeT0iOS44OTk0MSIgcj0iNiIgdHJhbnNmb3JtPSJyb3RhdGUoLTQ1IDkuODk5NSA5Ljg5OTQxKSIgc3Ryb2tlPSIjODA4MDgwIiBzdHJva2Utd2lkdGg9IjIiIGZpbGw9Im5vbmUiIC8+CiAgICA8cmVjdCBjbGFzcz0icmVjdCIgeD0iMTQuNDQxNSIgeT0iMTUuMTUzMyIgd2lkdGg9IjEiIGhlaWdodD0iOSIgcng9IjAuNSIgdHJhbnNmb3JtPSJyb3RhdGUoLTQ1IDE0LjQ0MTUgMTUuMTUzMykiIC8+Cjwvc3ZnPg==";